import React from "react";
import MasonryGallery from "../components/MasonryGallery";
import Navigation from "../components/Navigation";
import Footer from "../components/Footer";

const CustomCursor = () => {
    const [position, setPosition] = React.useState({ x: 0, y: 0 });
    const [isHovering, setIsHovering] = React.useState(false);

    React.useEffect(() => {
        const handleMouseMove = (e) => {
            setPosition({ x: e.clientX, y: e.clientY });
        };

        const handleMouseOver = (e) => {
            if (e.target.closest("button, a, .cursor-hover")) {
                setIsHovering(true);
            } else {
                setIsHovering(false);
            }
        };

        window.addEventListener("mousemove", handleMouseMove);
        window.addEventListener("mouseover", handleMouseOver);

        return () => {
            window.removeEventListener("mousemove", handleMouseMove);
            window.removeEventListener("mouseover", handleMouseOver);
        };
    }, []);

    return (
        <div
            className="fixed pointer-events-none z-[9999] mix-blend-difference hidden md:block"
            style={{
                left: position.x,
                top: position.y,
                transform: "translate(-50%, -50%)",
            }}
        >
            <div
                className={`rounded-full bg-white transition-all duration-300 ease-out ${
                    isHovering ? "w-7 h-7 opacity-50" : "w-3 h-3 opacity-100"
                }`}
            />
        </div>
    );
};

const FashionGallery = () => {
    const images = [
    'https://ik.imagekit.io/p3xaqnkci/tagteam/fashion/fashion-webp/f1.webp',
    'https://ik.imagekit.io/p3xaqnkci/tagteam/fashion/fashion-webp/f2.webp',
    'https://ik.imagekit.io/p3xaqnkci/tagteam/fashion/fashion-webp/f3.webp',
    'https://ik.imagekit.io/p3xaqnkci/tagteam/fashion/fashion-webp/f4.webp',
    'https://ik.imagekit.io/p3xaqnkci/tagteam/fashion/fashion-webp/f5.webp',
    'https://ik.imagekit.io/p3xaqnkci/tagteam/fashion/fashion-webp/f6.webp',
    'https://ik.imagekit.io/p3xaqnkci/tagteam/fashion/fashion-webp/f7.webp',
    'https://ik.imagekit.io/p3xaqnkci/tagteam/fashion/fashion-webp/f8.webp',
    'https://ik.imagekit.io/p3xaqnkci/tagteam/fashion/fashion-webp/f9.webp',
    'https://ik.imagekit.io/p3xaqnkci/tagteam/fashion/fashion-webp/f10.webp',
    'https://ik.imagekit.io/p3xaqnkci/tagteam/fashion/fashion-webp/f11.webp',
    'https://ik.imagekit.io/p3xaqnkci/tagteam/fashion/fashion-webp/f12.webp',
    'https://ik.imagekit.io/p3xaqnkci/tagteam/fashion/fashion-webp/f13.webp',
    'https://ik.imagekit.io/p3xaqnkci/tagteam/fashion/fashion-webp/f14.webp',
    'https://ik.imagekit.io/p3xaqnkci/tagteam/fashion/fashion-webp/f15.webp',
    'https://ik.imagekit.io/p3xaqnkci/tagteam/fashion/fashion-webp/f16.webp',
    'https://ik.imagekit.io/p3xaqnkci/tagteam/fashion/fashion-webp/f17.webp',
    'https://ik.imagekit.io/p3xaqnkci/tagteam/fashion/fashion-webp/f18.webp',
    'https://ik.imagekit.io/p3xaqnkci/tagteam/fashion/fashion-webp/f19.webp',
    'https://ik.imagekit.io/p3xaqnkci/tagteam/fashion/fashion-webp/f20.webp',
    'https://ik.imagekit.io/p3xaqnkci/tagteam/fashion/fashion-webp/f21.webp',
    'https://ik.imagekit.io/p3xaqnkci/tagteam/fashion/fashion-webp/f22.webp',
    'https://ik.imagekit.io/p3xaqnkci/tagteam/fashion/fashion-webp/f23.webp',
    'https://ik.imagekit.io/p3xaqnkci/tagteam/fashion/fashion-webp/f24.webp',
    'https://ik.imagekit.io/p3xaqnkci/tagteam/fashion/fashion-webp/f25.webp',
    'https://ik.imagekit.io/p3xaqnkci/tagteam/fashion/fashion-webp/f26.webp',
    'https://ik.imagekit.io/p3xaqnkci/tagteam/fashion/fashion-webp/f27.webp',
    'https://ik.imagekit.io/p3xaqnkci/tagteam/fashion/fashion-webp/f28.webp',
    'https://ik.imagekit.io/p3xaqnkci/tagteam/fashion/fashion-webp/f29.webp',
    'https://ik.imagekit.io/p3xaqnkci/tagteam/fashion/fashion-webp/f30.webp',
    'https://ik.imagekit.io/p3xaqnkci/tagteam/fashion/fashion-webp/f31.webp',
    'https://ik.imagekit.io/p3xaqnkci/tagteam/fashion/fashion-webp/f32.webp',
    'https://ik.imagekit.io/p3xaqnkci/tagteam/fashion/fashion-webp/f33.webp',
    'https://ik.imagekit.io/p3xaqnkci/tagteam/fashion/fashion-webp/f34.webp',
    'https://ik.imagekit.io/p3xaqnkci/tagteam/fashion/fashion-webp/f35.webp',
    'https://ik.imagekit.io/p3xaqnkci/tagteam/fashion/fashion-webp/f37.webp',
    'https://ik.imagekit.io/p3xaqnkci/tagteam/fashion/fashion-webp/f38.webp',
    'https://ik.imagekit.io/p3xaqnkci/tagteam/fashion/fashion-webp/f39.webp',
    'https://ik.imagekit.io/p3xaqnkci/tagteam/fashion/fashion-webp/f40.webp',
    'https://ik.imagekit.io/p3xaqnkci/tagteam/fashion/fashion-webp/f41.webp',
    'https://ik.imagekit.io/p3xaqnkci/tagteam/fashion/fashion-webp/f42.webp',
    'https://ik.imagekit.io/p3xaqnkci/tagteam/fashion/fashion-webp/f43.webp',
    'https://ik.imagekit.io/p3xaqnkci/tagteam/fashion/fashion-webp/f44.webp',
    'https://ik.imagekit.io/p3xaqnkci/tagteam/fashion/fashion-webp/f45.webp',
    'https://ik.imagekit.io/p3xaqnkci/tagteam/fashion/f46.gif',
    'https://ik.imagekit.io/p3xaqnkci/tagteam/fashion/f47.gif',
    'https://ik.imagekit.io/p3xaqnkci/tagteam/fashion/f48.gif',
    'https://ik.imagekit.io/p3xaqnkci/tagteam/fashion/f49.jpeg',
    'https://ik.imagekit.io/p3xaqnkci/tagteam/fashion/f50.jpeg',
    'https://ik.imagekit.io/p3xaqnkci/tagteam/fashion/f51.jpeg',
    ];

    return (
        <div className="bg-neutral-950 min-h-screen" style={{ cursor: "none" }}>
            <CustomCursor />
            <Navigation />
            <MasonryGallery
                title="EDITORIAL WORK"
                subtitle="FASHION & POTRAITS"
                images={images}
            />

            <Footer />
        </div>
    );
};

export default FashionGallery;
